import { TemplateMail } from "domain/entities/template-mail";
import { TemplateMailInputFilter } from "domain/models/template-mail-input-filter";
import { useTemplateMailsByFilter } from "presentation/hooks/use-query-template-mail";
import { useFilterNotificationStore } from "presentation/stores/use-filter-notification-store";
import { useTemplateMailStore } from "presentation/stores/use-template-mail-store";
import { Column } from "primereact/column";
import {
  DataTable,
  DataTableFilterEvent,
  DataTableFilterMetaData,
  DataTablePageEvent,
  DataTableSortEvent,
} from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import NotificationForm from "../NotificationForm";
import HeaderNotificationGrid from "./HeaderNotificationGrid";
import "./index.css";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { useParameterByFilter } from "presentation/hooks/use-query-parameter";
import { useParameterStore } from "presentation/stores/use-parameter-store";

const NotificationGrid: React.FC = () => {
  const toast = useRef<Toast>(null);
  const { filters, setFilters } = useFilterNotificationStore();
  const { templateMail, setTemplateMail } = useTemplateMailStore();
  const { objectType, setObjectType } = useParameterStore();
  const [showModal, setShowModal] = useState(false);
  const [lazyParams, setLazyParams] = useState({
    sortBy: "name",
    sortOrder: "asc",
    limit: 50,
    page: 1,
    filters: {},
  });
  const { data: parameters } = useParameterByFilter({
    limit: 1000,
    query: "objectType",
    sortBy: "value",
  } as BaseInputFilter);

  const {
    data: templateData,
    isLoading,
    refetch,
  } = useTemplateMailsByFilter({
    sortBy: lazyParams.sortBy,
    sortOrder: lazyParams.sortOrder,
    page: lazyParams.page,
    limit: lazyParams.limit,
    ...lazyParams.filters,
  } as TemplateMailInputFilter);

  useEffect(() => {
    setObjectType(
      parameters?.data?.filter((item) => item.type === "objectType")
    );
  }, [parameters]);

  useEffect(() => {
    setLazyParams((prev) => ({
      ...prev,
      filters: Object.fromEntries(
        Object.entries(filters)
          .map(([key, value]) => {
            if ("constraints" in value) {
              return [key, value.constraints?.[0]?.value ?? ""];
            }
            return [key, (value as DataTableFilterMetaData)?.value ?? ""];
          })
          .filter(
            ([_, value]) =>
              value !== null && value !== undefined && value !== ""
          )
      ),
    }));
  }, [filters]);

  useEffect(() => {
    refetch();
  }, [lazyParams.filters, refetch]);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const showActionOptions = (rowData: TemplateMail) => {
    return (
      <div className="spacing-icons">
        <i
          className="pi pi-pencil cursor-pointer"
          onClick={() => {
            setTemplateMail(rowData);
            setShowModal(true);
          }}
        />
      </div>
    );
  };

  return (
    <div className="parameter-grid ">
      <div className="parameter-4-cols">
        <DataTable
          value={templateData?.data || []}
          lazy
          paginator
          first={(lazyParams.page - 1) * lazyParams.limit}
          rows={lazyParams.limit}
          totalRecords={templateData?.pagination?.count || 0}
          loading={isLoading}
          onPage={(e: DataTablePageEvent) =>
            setLazyParams({
              ...lazyParams,
              page: e.page ? e.page + 1 : 1,
              limit: e.rows,
            })
          }
          sortField={lazyParams.sortBy}
          sortOrder={lazyParams.sortOrder === "asc" ? 1 : -1}
          onSort={(e: DataTableSortEvent) =>
            setLazyParams({
              ...lazyParams,
              sortBy: e.sortField,
              sortOrder:
                e.sortOrder === -1 ? "desc" : e.sortOrder === 1 ? "asc" : "",
            })
          }
          onFilter={(e: DataTableFilterEvent) => setFilters(e.filters)}
          filters={filters}
          size="small"
          resizableColumns
          columnResizeMode="expand"
          header={<HeaderNotificationGrid />}
          rowsPerPageOptions={[5, 10, 25, 50]}
          paginatorLeft
          dataKey="id"
        >
          <Column
            field="object"
            header="Tipo de objeto"
            sortable
            filter
            showFilterMatchModes={false}
          />
          <Column
            field="name"
            header="Nome do template"
            sortable
            filter
            showFilterMatchModes={false}
          />
          <Column
            field="subject"
            header="Assunto"
            sortable
            filter
            showFilterMatchModes={false}
          />
          <Column
            body={showActionOptions}
            header="Ações"
            align="center"
            alignHeader="center"
          />
        </DataTable>
      </div>
      <Dialog
        header="Template de E-mail"
        visible={showModal}
        style={{ width: "60vw" }}
        onHide={handleCloseModal}
      >
        <NotificationForm onClose={handleCloseModal} />
      </Dialog>
    </div>
  );
};
export default NotificationGrid;
